import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TenantConfigService } from '../../../core/tenant/tenant-config.service';
import { APP_VERSION } from '../../../core/version';

/**
 * Footer component displaying copyright information.
 * Uses a getter for the current year since Date is not a reactive signal.
 * Dynamically displays tenant name from TenantConfigService.
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  private readonly tenantConfig = inject(TenantConfigService);

  /** The tenant organization name from configuration */
  protected readonly tenantName = this.tenantConfig.displayName;

  /** The application version from build-time stamp */
  protected readonly appVersion = APP_VERSION;

  /**
   * Gets the current year for copyright display.
   * Uses a getter instead of computed() because Date is not a signal.
   */
  get year(): number {
    return new Date().getFullYear();
  }
}
